/** NOTE: When there are multiple error messages associated with a single code, 
* the first entry in the array below will be used as the 'default' response for that code
* More specified errors may use the 'text' parameter to match the text from the actual 
* Amadeus Error response. 
**/

export default [
  {
    code: null,
    displayMessage: "An unknown error occured.",
  },
  /*
  {
    code: null,
    text: "Invalid or Expired Offer",
    displayMessage: "The fare for the selected flight has expired. Please choose a different flight.",
  },
  */
  {
    code: 288,
    text: "UNABLE TO SATISFY, NEED CONFIRMED FLIGHT STATUS",
    displayMessage: "The selected flight could not be booked. The flight may be sold out or no longer be available.",
  },
  {
    code: 339,
    text: "NEED NAMES",
    displayMessage: "Passenger name missing or incorrect.",
  },
  {
    code: 911,
    text: "NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS",
    displayMessage: "The flight you selected is not available. Please try selecting a different flight.",
  },
  {
    code: 39007,
    text: "Invalid/Expired Offer",
    displayMessage: "The fare for the selected flight has expired. Please choose a different flight.",
  },
  {
    code: 38660,
    text: "Unable to proceed - Failed on provider side",
    displayMessage: "Sorry, we were unable to book you on the selected flight. The airline refused the booking for an unknown reason. (NDC)",
  },
  {
    code: 38629,
    text: "The flight is not available and waitlist is closed",
    displayMessage: "Sorry, we were unable to book you on the selected flight. The flight may be sold out or no longer be available.",
  },
  {
    code: 41250,
    text: "Offer not found",
    displayMessage: "The requested flight is expired or unavailable. Please restart your search to try again.",
  },
  {
    code: 8111,
    text: "NEED NAME",
    displayMessage: "Traveler name missing or incorrect.",
  },
  {
    code: 9092,
    text: "FREQUENT GUEST NUMBER REQUIRED",
    displayMessage: "A hotel frequent guest number is required to book the selected rate.",

  },
  {
    code: 10192,
    displayMessage: "The car rental company denied the booking. This may be due an incorrect loyalty number, or other incorrect information.",
  },
  {
    code: 10192,
    text: "QUOTE EXPIRED",
    displayMessage: "The car rental quote has expired. Please search for a new car rental selection.",
  },
  {
    code: 10192,
    text: "INVALID WIZARD NUMBER",
    displayMessage: "The Avis Wizard number provided is invalid or does not match the traveler name.",
  },
  {
    code: 10192,
    text: "NAME DOES NOT MATCH WIZARD PROFILE",
    displayMessage: "The Avis Wizard number provided is invalid or does not match the traveler name.",

  },
  {
    code: 10192,
    text: "MISSING SSR",
    displayMessage: "Please ensure profile information is complete.",

  },
];

